import { Monitor, X } from "lucide-react";

/**
 * Docked right panel hosting the live desktop (noVNC), Devin-style. On desktop it
 * occupies a grid column; on mobile it slides in as a full overlay. The noVNC WS
 * is proxied (auth-gated) through the gateway at /novnc.
 */
export function RightPanel({ open, onClose }: { open: boolean; onClose: () => void }) {
  const src = `/novnc/vnc.html?path=${encodeURIComponent("novnc/websockify")}&autoconnect=true&resize=scale&reconnect=true`;
  return (
    <aside className={`right-panel ${open ? "open" : ""}`} aria-hidden={!open}>
      <div className="rp-tabs">
        <span className="rp-tab active">
          <Monitor size={13} /> Desktop
        </span>
        <span className="rp-spacer" />
        <button className="ghost icon" onClick={onClose} aria-label="Close panel">
          <X size={16} />
        </button>
      </div>
      <div className="rp-body">
        {open && (
          <iframe
            className="rp-frame"
            title="Atlas desktop"
            src={src}
            allow="autoplay; clipboard-read; clipboard-write"
          />
        )}
      </div>
    </aside>
  );
}
